module.exports = __webpack_public_path__ + "img/laniel-logo.e1e3c53c.svg";